import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import UsersPage from "../modules/Users/UsersPage";

export function Users() {
    const header = useHeader();
    header.setTitle(useIntl().formatMessage({
        id: "users-page-title",
        defaultMessage: "Users"
    }));
    const subheader = useSubheader();
    subheader.setCustomClassName("subheader-custom-height");
    subheader.setDisplaySubheader(false);

    return <UsersPage/>;
}
